export default __webpack_public_path__ + "static/media/IMAC.d04e0431.png";